var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLdsuWidget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H14",
    stroke: "#828FAB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66666 7.47132C4.66668 7.38309 4.70168 7.29846 4.76399 7.23599L6.09732 5.90266C6.12829 5.87162 6.16507 5.84699 6.20557 5.83018C6.24606 5.81338 6.28948 5.80473 6.33332 5.80473C6.37717 5.80473 6.42058 5.81338 6.46108 5.83018C6.50158 5.84699 6.53836 5.87162 6.56932 5.90266L8.76399 8.09732C8.79495 8.12837 8.83174 8.15299 8.87223 8.1698C8.91273 8.1866 8.95615 8.19525 8.99999 8.19525C9.04383 8.19525 9.08725 8.1866 9.12775 8.1698C9.16824 8.15299 9.20503 8.12837 9.23599 8.09732L12.0973 5.23599C12.1439 5.18929 12.2033 5.15746 12.268 5.14453C12.3326 5.1316 12.3997 5.13815 12.4607 5.16334C12.5216 5.18854 12.5737 5.23125 12.6104 5.28607C12.6471 5.3409 12.6666 5.40537 12.6667 5.47132V10.6667C12.6667 10.8435 12.5964 11.013 12.4714 11.1381C12.3464 11.2631 12.1768 11.3333 12 11.3333H5.33332C5.15651 11.3333 4.98694 11.2631 4.86192 11.1381C4.73689 11.013 4.66666 10.8435 4.66666 10.6667V7.47132Z",
    stroke: "#828FAB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdsuWidget);
export default __webpack_public_path__ + "static/media/ldsu-widget.e1e96dade7c2b23f8aa9a6b78361cb37.svg";
export { ForwardRef as ReactComponent };